module.exports = __webpack_public_path__ + "static/img/sence2.ebad035.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/news2/sence2.png
// module id = kLxx
// module chunks = 7